export explainers = [
	title: "The central point of your networking"
	body: "From WhatsApp to Instagram to LinkedIn, provide people with the ability to connect with you like never before from one central hub."
,
	title: "Let your clients engage with you"
	body: "You have an infinite amount of ways to allow users interact with you, limited only by your imagination. Let customers pay you with Zelle, Venmo, or Cash App. Book an appointment with your booking system. Provide directions to your address, add links to your products, and much more!"
	imageWidth: 389
,
	title: "The easiest way to spread your name across the world"
	body: """
	Anyone with a smartphone camera is able to scan your customized Q-Code™ to get immediate access to your card.<br /><br />
	Sharing options allow you and your users to share your card to any platform with a click of a button.
	"""
,
	title: "Retain a lasting presence with clients"
	body: "Using cutting-edge technology, users and clients are able to save you as a contact in their phone book directly from your digital card. Better yet, users can save your card directly to their home screen and always have direct access to you at a moment’s notice."
	contentWidth: 515
,
	title: "Your very own landing page"
	body: "Forget expensive websites and long development times, get instant access to your own “landing page” that has everything users and clients need to engage with you."
	# TODO: append the following back to body when implementation is ready
	# Top it up by hosting your card on your custom domain website address for an additional $9.99/month."
,
	title: "Make 20% profit on each referral"
	body: "Any user that clicks on the referral button of your digital card and completes a purchase of a digital card will have you receive 20% of the order total to your bank of choice.*"
	note: "*Available to pro version customers only"
	imageWidth: 450
]